export function handleError(err: any): Promise<any> {
    let rejectWithMessage = "Unexpected error occurred - please contact an administrator if the issue persists.";

    if (err.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        rejectWithMessage = `Client error occurred - please contact an administrator if the issue persists.`;
        console.log(`Client error: ${err.error.message}`);
    } else if (err.error && err.error.displayMessage) {
        // if the response body is json and "displayMessage" exists, then assume it's
        // an instance of PortalServerErrorException
        rejectWithMessage = `Server error (${err.status}): ${err.error.displayMessage}`;
        console.log(`Server error (${err.status}): ${err.error.logMessage}`);
    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        if (err.status == 401) {
            rejectWithMessage = `Security token expired - please login again.`
        }
        else {
            rejectWithMessage = `Server error (${err.status}) - please contact an administrator if the issue persists.`
            console.log(`Server error (${err.status}): ${err.error}`);
        }
    }

    return Promise.reject(rejectWithMessage);
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/shared/handle-error.ts